import React from "react";
import "./App.css";

import StatsBar from "./components/StatsBar";
import ServiceCard from "./components/ServiceCard";
import logoImg from "./assets/logo.png"; // Le logo principal

function App() {
  return (
    <div className="App">
      
      {/* --- HERO SECTION --- */}
      <div className="hero-content-wrapper">
        
        {/* Logo Principal */}
        <div className="hero-logo-container">
          <img src={logoImg} alt="NewCo Logo" className="hero-logo-img" />
        </div>

        <div className="hero-bg-image"></div>
        <div className="hero-diagonal-overlay"></div>

        <div className="container hero-text-container">
          <h1 className="hero-title">
            NEWCOGROUP : La convergence de l'IT Bancaire et de la Data.
          </h1>
        </div>

        <StatsBar />
      </div>

      {/* --- INTRO --- */}
      <section className="intro-section">
        <div className="container">
          <p className="intro-text">
            NEWCOGROUP est une structure holding de tête, dont la formation a
            été initiée en septembre 2022. Notre vocation est claire : réunir et
            structurer des expertises de pointe dans les domaines de l'IT
            bancaire et de la Data au sein d'un même ensemble cohérent.
          </p>
        </div>
      </section>

      {/* --- SERVICES --- */}
      <section className="services-section">
        <div className="container cards-wrapper">
          
          {/* Carte 1 : PARTNERS */}
          <ServiceCard
            variant="blue"
            title="PARTNERS"
            buttonText="Aller vers NewCo Partners"
            linkUrl="https://www.newco-partners.com/"
          >
            <p style={{ color: "#273782" }}>
              NewCo Partners est un cabinet de{" "}
              <strong>conseil multi-spécialiste</strong> dans l'accompagnement
              des <strong>établissements financiers</strong> dans la mise en œuvre de projets liés aux systèmes d’information sur les silos fonctionnels de la finance de marché ou de la réglementation bancaire.
            </p>
            <p style={{ marginTop: "10px", fontSize: "0.85rem", color: "#004e92", fontWeight: "bold" }}>
              Spécialistes de la convergence Finance/Risques, de la Conformité bancaire et des marchés financiers, nous intervenons auprès des grandes institutions financières.
            </p>
            <p style={{ marginTop: "10px", color: "#273782" }}>
              Nous vous accompagnons depuis les phases amont d’expression de besoin métier, jusqu’à la mise en œuvre opérationnelle des projets.
            </p>
          </ServiceCard>

          {/* Carte 2 : DATA SERVICES */}
          <ServiceCard
            variant="green"
            title="DATA SERVICES"
            buttonText="Aller vers NewCo Data Services"
            linkUrl="https://newcodata.fr/"
          >
            <p>
              NewCo Data Services est un cabinet de <strong>conseil spécialisé</strong> dans l’accompagnement des <strong>établissements</strong> pour relever leurs défis liés à la donnée.
            </p>
            <p style={{ marginTop: "10px", fontSize: "0.85rem", color: "#95C11F", fontWeight: "bold" }}>
              Fort d’une expertise reconnue, NewCo Data Services intervient sur l’ensemble des aspects d’un projet Data, depuis la définition stratégique jusqu’à la mise en œuvre opérationnelle.
            </p>
            <p>
              Une expertise à 360° autour de la donnée NewCo Data Services mobilise ses compétences à chaque étape clé des projets Data.
            </p>
          </ServiceCard>
          
        </div>
      </section>

    </div>
  );
}

export default App;